import moment from 'moment-timezone';
import qs from 'qs';
import {
  PROJECT_SPECIFICATIONS_REQUEST,
  PROJECT_SPECIFICATIONS_FAILURE,
  PROJECT_SPECIFICATIONS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function projectSpecificationsRequest() {
  return {
    type: PROJECT_SPECIFICATIONS_REQUEST,
  };
}

function projectSpecificationsSuccess(data, token = null) {
  return {
    type: PROJECT_SPECIFICATIONS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function projectSpecificationsError(message) {
  return {
    type: PROJECT_SPECIFICATIONS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchProjectSpecifications(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(projectSpecificationsRequest());
    if (!fresh) {
      let projectSpecificationsData = {};
      try {
        projectSpecificationsData = JSON.parse(getItem(`${config.get('appName')}.projectSpecifications`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !projectSpecificationsData.data ||
        config.get('version') !== projectSpecificationsData.version ||
        moment().isAfter(moment(projectSpecificationsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectSpecificationsSuccess(projectSpecificationsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/specifications/projects/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.projectSpecifications`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(projectSpecificationsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, projectSpecificationsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/projectSpecifications.js